module.exports = __webpack_public_path__ + "img/hero-lg.f96204df.svg";